module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "method": "POST",
      "name": "external_returns_form",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "externalReturn"
    }
  }, [(_vm.isReturnsLoaded) ? _c('Returns', [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.selected_returns_tab_id === 0 && _vm.returns.format === 'sheet') ? _c('ReturnSheet') : _vm._e(), _vm._v(" "), (_vm.selected_returns_tab_id === 0 && _vm.returns.format === 'question') ? _c('ReturnQuestion') : _vm._e(), _vm._v(" "), (_vm.selected_returns_tab_id === 0 && _vm.returns.format === 'data') ? _c('ReturnData') : _vm._e(), _vm._v(" "), (_vm.selected_returns_tab_id === 1 && _vm.returns.lodgement_date != null) ? _c('ReturnSubmit') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showButtons),
      expression: "showButtons"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.isPayable) ? _c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Return submission fee: " + _vm._s(_vm._f("toCurrency")(_vm.returns_estimate_fee)))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.spinner_exit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Saving")]) : (!_vm.spinner_exit && _vm.disable_exit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "save_exit"
    }
  }, [_vm._v("Save and Exit")]) : _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "save_exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save(false)
      }
    }
  }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.spinner_continue) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Saving")]) : (!_vm.spinner_continue && _vm.disable_continue) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "save_continue"
    }
  }, [_vm._v("Save and Continue")]) : _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "save_continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save(true)
      }
    }
  }, [_vm._v("Save and Continue")]), _vm._v(" "), (_vm.spinner_submit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")]) : _vm._e(), _vm._v(" "), (!_vm.spinner_submit && !_vm.isPayable && _vm.isSubmittable && !_vm.disable_submit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save_and_submit()
      }
    }
  }, [_vm._v("Submit")]) : (!_vm.spinner_submit && _vm.disable_submit && !_vm.isPayable && _vm.isSubmittable) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "submit"
    }
  }, [_vm._v("Submit")]) : (!_vm.spinner_submit && !_vm.disable_submit && _vm.isPayable && _vm.isSubmittable) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit_and_checkout()
      }
    }
  }, [_vm._v("Pay and Submit")]) : (_vm.isPayable && _vm.isSubmittable && _vm.disable_submit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "submit"
    }
  }, [_vm._v("Pay and Submit")]) : _vm._e()])])])])])], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09d6b7bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/return.vue
// module id = 916
// module chunks = 0